import React from 'react';
import cvData from '../data/cvData.json';

const Education = () => {
  const { education } = cvData;

  return (
    <section id="education" className="relative z-10 mx-auto w-full max-w-6xl px-6 py-12">
      <h2 className="section-title">Education</h2>
      <div className="mt-8 space-y-6">
        {education.map((edu, index) => (
          <div key={index} className="glass-card p-6 md:p-8">
            <h3 className="text-2xl font-semibold text-white">
              {edu.institution}
            </h3>
            <p className="mt-2 text-base font-medium text-text-secondary">
              {edu.degree}
            </p>
            <p className="mt-2 text-sm italic text-text-secondary">{edu.year}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Education;
